import { AxiosResponse } from "axios";
import { MERCHANT_V3_API_URLS as M3_API } from "@/apps/merchant3/services/apiClient/apiUrl";
import IAddress from "@/apps/merchant3/types/IAddress";
import { jwtApiClient } from "@/apps/merchant3/services/apiClient/apiClient";

export const recordAddress = (
  cartTag: string,
  address: IAddress
): Promise<AxiosResponse> => {
  return jwtApiClient.put(M3_API(cartTag).RECORD_ADDRESS, {
    street1: address.street1,
    street2: address.street2,
    neighborhood: address.neighborhood,
    city: address.city,
    state: address.state,
    stateCode: address.stateCode,
    postalCode: address.postalCode,
    country: address.country,
  });
};
